<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="ERP单号:" prop="erpOrderNum" clearable>
        <el-input v-model.trim="searchForm.erpOrderNum" placeholder="请输入erp单号" />
      </el-form-item>
      <el-form-item label="项目名称:" prop="projectName" clearable>
        <el-input v-model.trim="searchForm.projectName" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="合同编号:" prop="contractNum">
        <el-input v-model="searchForm.contractNum" placeholder="请输入合同编号" @blur="searchForm.contractNum = (searchForm.contractNum || '').trim()" />
      </el-form-item>
      <el-form-item label="订货单位:" prop="orderUnitName">
        <el-input v-model="searchForm.orderUnitName" placeholder="请输入订货单位" />
      </el-form-item>
      <el-form-item label="合同时间:" prop="createBeginTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="Loading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>

      <div v-loading="tableLoading" class="tableBody">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="查看约定交付日期" align="left" width="130" fixed="left">
            <template v-slot="{row}">
              <el-button type="text" @click="showProductReadyDate(row.contractNum)">
                查看
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="contractNum" label="合同编号" align="left" min-width="150" />
          <el-table-column prop="erpOrderNum" label="ERP订单号" align="left" min-width="130" />
          <el-table-column prop="projectName" label="项目名称" align="left" min-width="180" />
          <el-table-column prop="orderUnitName" label="订货单位(乙方)" align="left" min-width="150" />
          <el-table-column prop="contractCreateTime" label="合同时间" align="left" min-width="120" />
          <el-table-column prop="getReadyDate" label="齐套日期" align="left" min-width="120" />
        </el-table>
        <div style="text-align: right;margin-top: 10px">
          <el-pagination
            :page-sizes="[10]"
            :page-size.sync="page.pageSize"
            :current-page.sync="page.currentPage"
            layout="total, prev, pager, next, jumper,sizes"
            :total="page.total"
            hide-on-single-page
            @size-change="handerSizeChange"
            @current-change="handerCurrentChange"
          />
        </div>
      </div>
    </el-form>
    <el-dialog title="查看约定交付日期" :visible.sync="contractVisible" width="820px">
      <delivery-date v-if="contractVisible" :str-contract-code="contractNum" />
    </el-dialog>
    <!-- <contract-file-dialog ref="fileDialog" /> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { selectDeliveryDateForAssistant } from '@/API';
import deliveryDate from '../Chief/contract/common/deliveryDate';
export default {
  //, getAgreedDeliveryDate
  data () {
    return {
      searchForm: {
        erpOrderNum: '',
        projectName: '',
        contractNum: '',
        orderUnitName: '',
        createBeginTime: '',
        createEndTime: ''
      },
      contractNum: '',
      contractVisible: false,
      tableLoading: false,
      tableData: [
      ],
      Loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.createBeginTime) {
            let date = new Date(this.searchForm.createBeginTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      }
    };
  },
  components: {
    deliveryDate
  },
  computed: {
    ...mapState({
      salesTypeList: state => state.enumeration.salesTypeList, //  现销/赊销
      contractStatus: state => state.enumeration.contractStatus,
      postStatus: state => state.enumeration.postStatus
    })
  },
  methods: {
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.createEndTime = '';
      this.page.currentPage = 1;
      this.doSearch();
    },
    showFile (row) {
      this.$refs.fileDialog.showFile(row.contractId);
    },
    handerSizeChange () {
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange () {
      this.doSearch();
    },
    // 查看合同中各个产品齐套情况
    showProductReadyDate (val) {
      this.contractNum = val;
      this.contractVisible = true;
      // getAgreedDeliveryDate(this.contractNum).then((res) => {
      //   let json = res.data;
      //   this.loading = false;
      //   if (json.status === '200') {
      //     this.tableData = json.data;
      //   }
      // }).catch(() => {
      //   this.loading = false;
      // });
    },
    doSearch () {
      this.tableLoading = true;

      selectDeliveryDateForAssistant({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.dt;
          this.page.total = json.data.totalCount;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>

<style>

</style>
